import { render, staticRenderFns } from "./TermItem.vue?vue&type=template&id=125d7fea"
import script from "./TermItem.vue?vue&type=script&lang=js"
export * from "./TermItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports